import { useMutation, useQueryClient } from "@tanstack/react-query";

import { logger } from "#app/monitoring/Logger";
import { showErrorToast, showSuccessToast } from "#app/notifications";
import { companyQuery } from "#modules/company/infra/company.query";
import {
  CompanySettingsPayload,
  updateCompanySetting,
} from "#modules/company/infra/updateCompanySetting.api";

type Options = { shouldNotNotify?: boolean };

export const useUpdateCompanySetting = (options?: Options) => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: async (data: CompanySettingsPayload) => {
      await updateCompanySetting(data);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries(companyQuery());
      if (!options?.shouldNotNotify) {
        showSuccessToast({ title: "Paramètres enregistrés" });
      }
    },
    onError: (err) => {
      logger.error(err);
      if (!options?.shouldNotNotify) {
        showErrorToast({
          title: "Erreur est survenue",
          message:
            err instanceof Error
              ? err.message
              : "Erreur est survenue lors de la mise à jour des paramètres de la companie",
        });
      }
    },
  });

  return { updateCompanySetting: mutate, ...rest };
};
